import { Fragment, useContext } from 'react'

import { ContentPage_content } from 'globalTypes'

import { Context as NoteContext } from 'Root/App/Contexts/Note'
import Note from 'Root/App/Item/Note'
import UserProfile from 'Root/App/Item/UserProfile'
import { useCurrentUserId } from 'lib/use-current-user-id'

interface Props {
  content: ContentPage_content
}

const BottomContent = ({ content }: Props) => {
  const currentUserId = useCurrentUserId()
  const { setElementId } = useContext(NoteContext)

  if (content.creator.id === currentUserId && !Boolean(content.note)) {
    return null
  }

  return (
    <Fragment>
      {Boolean(content.creator.id !== currentUserId) && (
        <UserProfile {...content.creator} isOnCollection />
      )}
      {Boolean(content.note) && (
        <button onClick={() => setElementId(content.id)}>
          <Note value={content.note} />
        </button>
      )}
    </Fragment>
  )
}

export default BottomContent
